<template>
  <div class="promotion-popup" :class="{ loading }">
    <popup :buttons="buttons" :close-action="closeModal">
      <template v-slot:title>
        <img class="logo-image" :src="require('@/assets/discount-riseup-friends.svg')">
        <div class="popup-title">מגיע לך חודש ללא חיוב מתנה!</div>
      </template>
      <template v-slot:content>
        <div class="description">
          <span>לקוחות דיסקונט שנרשמים לשירות עם אחד מכרטיסי האשראי של דיסקונט מקבלים
            <span class="bold">בנוסף לחודש הנסיון </span>גם חודש מנוי במתנה. </span>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import DiscountApi from '../../../api/DiscountApi';
import Segment from '../../../Segment';

export default {
  name: 'PromotionPopup',
  data() {
    return {
      loading: false,
    };
  },
  components: {
    RiseupButton: BaseUI.RiseupButton,
    Popup: BaseUI.Popup,
  },
  created() {
    Segment.trackUserGot('DiscountPromotionPopupShown');
  },
  computed: {
    buttons() {
      return [
        {
          title: 'הבנתי, תודה',
          action: this.closeModal,
          loading: this.loading,
          size: 'slim',
        },
      ];
    },
  },
  methods: {
    ...mapActions('credentials', ['updatePendingCredentials']),
    closeModal() {
      this.$emit('close');
    },
    async redirectToGetAccessCode() {
      this.loading = true;
      const { credentialsId } = await this.saveDiscountCredentials();
      const redirectUrl = await DiscountApi.getAccessCodeUrl(this.idNumber, credentialsId);
      window.location.href = redirectUrl;
    },
  },
};
</script>

<style lang="scss" scoped>

  .promotion-popup {
    &.loading{
      opacity: 0.5;
      pointer-events: none;
    }

    .popup-title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 18px;
    }

    .logo-image {
      width: 100%;
      text-align: center;
      height: 110px;
      margin-bottom: 30px;
    }

    .description {
      font-family: SimplerPro;
      margin-bottom: 80px;
      line-height: 1.38;
      text-align: center;

      .bold {
        font-weight: bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/onboarding/discount/PromotionPopup.vue